<template>
  <ul class="l-side-projects">
    <li
      v-for="project in filteredProjects"
      :key="project.id"
      class="l-side-projects__item"
    >
      <Collapse visible>
        <template slot="header">
          <p class="l-side-projects__name">{{ project.name }}</p>
        </template>
        <template slot="content">
          <ul
            v-if="project.partners && project.partners.length"
            class="l-side-partners"
          >
            <ListItemRoom
              v-for="partner in project.partners"
              :key="partner.id"
              :partner="partner"
              :project="project"
            />
          </ul>
        </template>
      </Collapse>
    </li>
  </ul>
</template>

<script>
import Collapse from '@/components/Collapse';
import ListItemRoom from '@/components/side/ListItemRoom';

export default {
  props: {
    search: {
      type: String,
      required: true
    }
  },
  components: {
    Collapse,
    ListItemRoom
  },
  computed: {
    filteredProjects() {
      // ルーム名もしくはパートナー名に、検索キーワードが含まれるルームを返す
      const projects = this.projects;
      const search = this.search;
      if (!search && search !== 0) {
        return projects;
      }
      let results = [];
      for (let i = 0; i < projects.length; i++) {
        let project = Object.assign({}, projects[i]);
        if (project.name.indexOf(search) !== -1) {
          results.push(project);
        } else {
          let partners = project.partners.filter(partner => {
            if (partner.name.indexOf(search) !== -1) {
              return true;
            }
          });
          if (partners.length) {
            project.partners = partners;
            results.push(project);
          }
        }
      }
      return results;
    },
    projects() {
      return this.$store.state.projects;
    }
  }
};
</script>
